var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"z-checkbox"},[_c('input',{staticClass:"checkbox-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_vm._v(" "),_c('span',{staticClass:"checkbox-display",class:{
      indeterminate: _vm.indeterminate
    }})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52df71f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZTable/ZCheckbox.vue
// module id = null
// module chunks = 